function PatientsTable({ patients, selectedEmails, onSelectionChange }) {
  const allSelected = patients.length > 0 && selectedEmails.length === patients.length
  const someSelected = selectedEmails.length > 0 && selectedEmails.length < patients.length

  const handleSelectAll = () => {
    if (allSelected) {
      onSelectionChange([])
    } else {
      onSelectionChange(patients.map(p => p.email))
    }
  }

  const handleSelectOne = (email) => {
    if (selectedEmails.includes(email)) {
      onSelectionChange(selectedEmails.filter(e => e !== email))
    } else {
      onSelectionChange([...selectedEmails, email])
    }
  }

  const formatServicesUsed = (services) => {
    if (!services || services.length === 0) return '-'

    const labels = {
      'medication-review': 'Medication Review',
      'flu-vaccination': 'Flu Vaccination',
      'blood-pressure': 'Blood Pressure',
      'smoking-support': 'Smoking Cessation'
    }

    return services.map(s => labels[s] || s).join(', ')
  }

  if (!patients || patients.length === 0) {
    return (
      <div className="empty-state">
        <p>No patients found</p>
      </div>
    )
  }

  return (
    <div className="patients-table-container">
      <table className="patients-table">
        <thead>
          <tr>
            <th className="checkbox-cell">
              <input
                type="checkbox"
                checked={allSelected}
                ref={(el) => {
                  if (el) el.indeterminate = someSelected
                }}
                onChange={handleSelectAll}
                title={allSelected ? 'Deselect all' : 'Select all'}
              />
            </th>
            <th>Full Name</th>
            <th>Email</th>
            <th>Age</th>
            <th>Services Used</th>
          </tr>
        </thead>
        <tbody>
          {patients.map((patient) => (
            <tr
              key={patient.email}
              className={selectedEmails.includes(patient.email) ? 'selected' : ''}
            >
              <td className="checkbox-cell">
                <input
                  type="checkbox"
                  checked={selectedEmails.includes(patient.email)}
                  onChange={() => handleSelectOne(patient.email)}
                />
              </td>
              <td>{patient.full_name}</td>
              <td>{patient.email}</td>
              <td>{patient.age}</td>
              <td>{formatServicesUsed(patient.services_used)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PatientsTable
